import { Flag, Pencil } from "components";
import { EndUserState } from "helpers";

interface UserTableDataOptionsProps {
  endUsers: EndUserState;
  onFlag: (endUsers: EndUserState) => void;
  onEdit: (endUsers: EndUserState) => void;
}

export const UserTableDataOptions = ({ endUsers, onFlag, onEdit }: UserTableDataOptionsProps) => {
  return (
    <div className="flex items-center justify-center space-x-3 bg-primary/5 py-5">
      <Pencil onClick={() => onEdit(endUsers)} />
      <Flag className={"text-primary"} onClick={() => onFlag(endUsers)} />
    </div>
  );
};
